/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { useCandidateData } from "./hooks/useCandidateData";
import Error from "./components/Error/Error";
import Loader from "./components/Loader/Loader";
import { getQueryParameter } from "./utils/common";
import TopCandidate from "./components/Mainview/TopCandidate";
import DataFact from "./components/Mainview/DataFact";
import Navigation from "./components/Mainview/Navigation";
import CandidatesDashboard from "./components/Canditates/CandidatesDashboard";
import CandidatesList from "./components/Canditates/CandidatesList";
import Finance from "./components/Mainview/Finance";
import TopCandidateDetails from "./components/Mainview/TopCandidateDetails";
import Sonndesfro from "./components/Mainview/Sonndesfro";
import House from "./components/Mainview/House";
import Result from "./components/Mainview/Result";

function App() {
  const { t, i18n } = useTranslation();
  const supportedLanguages = ["en", "fr", "de", "pt"];
  const language = i18n.language;
  const { data, loading, error } = useCandidateData();
  const [width, setWindowWidth] = useState(0);
  //
  const isDesktop = width > 750;

  useEffect(() => {
    setTimeout(() => {
      window.wort.frameResize();
    }, 500);
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    const lang = getQueryParameter("lang");
    if (supportedLanguages.includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

  if (loading) return <Loader />;

  if (!data || error) return <Error error={error} />;

  const partyId = Number(getQueryParameter("party"));
  const selectedParty = data.find((party) => party.partyId === partyId);
  const hasFinanceData =
    selectedParty.financialInfo.memberDonations?.length > 0;

  const hasSonndesfro = selectedParty.sonndesfro?.length > 0;
  const hasHouse = selectedParty.electedToChamber ? true : false;
  const hasElections = selectedParty.elections?.length > 0;
  const hasTopCandidateTimeline =
    selectedParty.topCandidateTimeline?.length > 0;
  const hasTopCandidate = selectedParty.topCandidateName ? true : false;

  function onPartySearch(query) {
    window.location.href = `?party=${query}`;
    window.wort.frameResize();
  }

  if (!selectedParty)
    return (
      <Error error={"Error! Please provide partyId parameter in the url."} />
    );
  return (
    <div className="px-5 mx-auto max-w-wort">
      <Header
        t={t}
        data={data}
        selectedParty={selectedParty}
        partyQueryHandler={onPartySearch}
      />
      <div className="md:flex flex-row">
        <TopCandidate selectedParty={selectedParty} t={t} language={language} />
        <DataFact t={t} data={selectedParty} />
      </div>
      <div className="hidden md:block h-0.5 bg-black bg-opacity-40 mt-4 mb-7"></div>
      <Navigation
        t={t}
        hasSonndesfro={hasSonndesfro}
        hasTopCandidate={hasTopCandidate}
        hasElections={hasElections}
      />
      <CandidatesDashboard t={t} data={selectedParty} />
      <CandidatesList t={t} data={selectedParty} />
      {hasFinanceData && <Finance t={t} data={selectedParty} />}
      {hasTopCandidate && (
        <TopCandidateDetails t={t} data={selectedParty} language={language} />
      )}
      {hasSonndesfro && <Sonndesfro t={t} data={selectedParty} />}
      {hasHouse && <House t={t} data={selectedParty} />}
      {hasElections && (
        <Result t={t} data={selectedParty} language={language} />
      )}
      <Footer t={t} data={data} partyQueryHandler={onPartySearch} />
    </div>
  );
}

export default App;
